import { createAuth0Client } from '@auth0/auth0-spa-js';

let auth0Client = null;
let initPromise = null;

export const getAuth0Client = async () => {
  if (auth0Client) {
    return auth0Client;
  }
  
  if (initPromise) {
    auth0Client = await initPromise;
    return auth0Client;
  }

  initPromise = createAuth0Client({
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: window.location.origin + '/login/callback',
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      scope: 'openid profile email read:messages'
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    useRefreshTokensFallback: false
  });

  try {
    auth0Client = await initPromise;
    return auth0Client;
  } catch (error) {
    console.error('Auth0 client creation failed:', error);
    initPromise = null; // Reset promise on error to allow retry
    throw error;
  }
};